import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/reducers";

import { AppSessionService } from "../app-session/app-session.service";

import { BaseResponse } from "src/app/models/common/baseResponse";
import { PageResponse } from "src/app/models/common/pageResponse";
import { Locale } from "src/app/models/Notifiables/locale";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import {
  setSimpleFilterQuery,
  setAdvancedFilterQuery,
} from "../../utils/tableUtils";
import { GridUtils } from "../../utils/gridUtils";

const EMPTY_STRING = "";
@Injectable({
  providedIn: "root",
})
export class LocalesService {
  private BASE_URL = this.appSession.baseUrl + "/api/v1/locales";

  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getLocales(options): Observable<BaseResponse<PageResponse<Locale>>> {
    let headers = new HttpHeaders({
      "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
    });

    if (options && options.enabled) {
      headers = headers.append("query", "enabled == true");
    }

    const url = `${this.appSession.baseUrl}/api/v1/locales/translated`;
    return this.http.get<BaseResponse<PageResponse<Locale>>>(url, { headers });
  }

  getLocalesList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }
    return this.http.get(this.buildDataUrl(paging, "?"), { headers });
  }

  getLocale(code): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.appSession.baseUrl + "/api/v1/locales"}/${code}`;

    return this.http.get(url, { headers });
  }

  updateLocale(locale): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(locale);
    const url = `${this.appSession.baseUrl + "/api/v1/locales"}/${locale.code}`;

    return this.http.put(url, data, { headers });
  }

  createLocale(locale): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(locale);
    const url = `${this.appSession.baseUrl + "/api/v1/locales"}`;

    return this.http.post(url, data, { headers });
  }

  private buildDataUrl(pagingArgs: any, path: string): string {
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/locales/translated"
    }${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;
    baseQueryString += query;
    return baseQueryString;
  }
}
